// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z8Ym","label":"styles_label__gQ9Kv"};